import { render, staticRenderFns } from "./ContactMain.vue?vue&type=template&id=f0a2274c&scoped=true&"
import script from "./ContactMain.vue?vue&type=script&lang=js&"
export * from "./ContactMain.vue?vue&type=script&lang=js&"
import style0 from "./ContactMain.vue?vue&type=style&index=0&id=f0a2274c&prod&lang=css&"
import style1 from "./ContactMain.vue?vue&type=style&index=1&id=f0a2274c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a2274c",
  null
  
)

export default component.exports